export enum ListPageType {
  partners,
  courses,
  devices,
  gameplay,
  players,
  users,
  partnerCourses
}
